import React, {useState} from "react";
import { ListItem,  ListItemText, List, IconButton } from '@mui/material';

import SendIcon from '@mui/icons-material/Send';
import HideSourceIcon from '@mui/icons-material/HideSource';
import AddIcon from '@mui/icons-material/Add';


const CommunicationsCard = (props) => {
    
var {nhtsaIdNumber, subject, summary, associatedProductsCount, associatedDocumentsCount} = props;

const [open, setOpen] = useState(false);

return (
    <List
        sx={{
            margin: 0,
            padding: 0,
            width: '100%',
            borderRadius: 0,
            borderColor: 'divider',
            //backgroundColor: '#ebe3e3',
            //p8Ozz44B5-MIXViQ3rOk
        }}
        
    >
        <ListItem>
            <ListItemText primary={`${subject}`} secondary= {`${summary?.substr(0, 150)}...`} />
        </ListItem>
        <ListItem>
            <ListItemText primary="NHTSA Number" secondary= {`${nhtsaIdNumber}`} />
            <ListItemText primary="Affected Products" secondary= {`${associatedProductsCount}`} />
            <ListItemText primary="Associated Documents" secondary= {`${associatedDocumentsCount}`} />
            <IconButton variant="contained" color="primary"><AddIcon /></IconButton>
            <IconButton onClick={()=>setOpen(true)} variant="contained" color="primary"><SendIcon /></IconButton>

        </ListItem>
        
    </List>
)}

export default CommunicationsCard;